import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";
import { BudgetDataRow } from "../types";

export const useBudgetForcase = (projectId: string | undefined, year?: number) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-adjustments", projectId, year],
        queryFn: () => commercialsApi.fetchForecast({ projectId, year }),
        enabled: !!projectId,
    });

    const project = data?.data?.project;
    // const budgets = data?.data?.project?.budgets_monthly;

    const structuredData =
        project && project.actuals_monthly.map((actual, index) => {
            const monthLabel = new Date(`${actual.month}-01`).toLocaleString("default", { month: "short", year: "numeric" });
            const row: BudgetDataRow = {
                month: monthLabel,
                Actual: { value: project.actuals_monthly?.[index].value ?? 0, cumulative: project.actuals_cumulative?.[index].value ?? 0 },
                Forecast: { value: project.forecast_monthly?.[index].value ?? 0, cumulative: project.forecast_cumulative?.[index].value ?? 0 },
                Baseline: { value: project.baseline_monthly?.[index].value ?? 0, cumulative: project.baseline_cumulative?.[index].value ?? 0 },
                LBE: { value: project.lbe_monthly?.[index].value ?? 0, cumulative: project.lbe_cumulative?.[index].value ?? 0 },
            };
            // if (budgets && Array.isArray(budgets)) {
            //     budgets.forEach((b, i) => {
            //         const key = `Budget${i + 1}` as `Budget${number}`;
            //         row[key] = b.months?.[index]?.total_value ?? 0;
            //     });
            // }

            return row;
        });

    return {
        structuredData,
        isLoading,
        isError,
        error,
    };
};